<div class="row neutral-100-bg pad-20 margin-bottom-20 cta-border">
  <h2 class="margin-bottom-10" dsContent [contentPath]="'claims.postFnol.postFnolCtaHeading'"></h2>
  <p class="margin-bottom-10" dsContent [contentPath]="'claims.postFnol.postFnolCtaPrompt'"></p>
  <ul class="bullet margin-bottom-10">
    <li class="margin-bottom-0" dsContent [contentPath]="'claims.postFnol.postFnolCtaBullet1'"></li>
    <li class="margin-bottom-0" dsContent [contentPath]="'claims.postFnol.postFnolCtaBullet2'"></li>
    <li class="margin-bottom-0" dsContent [contentPath]="'claims.postFnol.postFnolCtaBullet3'"></li>
  </ul>
  <button
    ds-button
    (click)="continueFlow()"
    dsContent
    [contentPath]="'claims.postFnol.postFnolCtaButton'"
    data-cy="claimDetailServicesButton"
  ></button>
</div>
